import {
    WALLET_LOADING,
    WALLET_ACCOUNT_LOADED,
    WALLET_ACCOUNT_SEARCHED,
    WALLET_TRANSACTION_LOADED,
    WALLET_FAILED,
    LOGOUT,
} from '../types';

const INIT_STATE = {
    accounts: [],
    accountsSearched: [],
    transactions: [],
    loading: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case WALLET_LOADING:
            return {...state, loading: true };

        case WALLET_ACCOUNT_LOADED:
            return {
                ...state,
                loading: false,
                accounts: action.payload,
            };

        case WALLET_ACCOUNT_SEARCHED:
            return {
                ...state,
                loading: false,
                accountsSearched: action.payload,
            };

        case WALLET_TRANSACTION_LOADED:
            return {
                ...state,
                loading: false,
                transactions: action.payload,
            };

        case WALLET_FAILED:
            return {
                ...state,
                loading: false,
            };

        case LOGOUT:
            return {...INIT_STATE };

        default:
            return {...state };
    }
};